import { QueryClient } from '@tanstack/react-query';

import { queryConfig } from '@/config/tanstack-query';

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});
